enum UserRoutesAPI {
  USER_LOCATION = '/customer-portal-service/User/Location',
  USER_SETTINGS = '/customer-portal-service/User/Settings',
  USER_CHANGE_PASSWORD = '/customer-portal-service/User/ChangePassword',
  USER_IS_TEMP_CREDENTIALS = '/customer-portal-service/User/TempCredentials/:id',
  USER_CUSTOMERS_LIST = '/customer-portal-service/User/Customers?page=0&limit=:limit',
  USER_DEFAULT = '/customer-portal-service/User',
  USER_IS_USER_PHILIPS = '/customer-portal-service/User/UserPhilips/:id',
}

enum UserRoutesApplication {
  USER_ITEM = '/application/user/:id',
}

export {
  UserRoutesAPI,
  UserRoutesApplication,
};
